const accordionData = {
  general: [
    {
      question: 'What is FairyTaler?',
      answer:
        'FairyTaler is an AI-powered storytelling app that creates personalized bedtime stories, songs, and relaxing sounds for children. Every story or song can be tailored to your child’s interests and imagination.',
    },
    {
      question: 'How does FairyTaler work?',
      answer:
        'Simply describe your idea, choose a style or theme, and the app instantly generates a story, song, or music using advanced AI.',
    },
    {
      question: 'Can I personalize content for my child?',
      answer:
        'Yes. You can customize stories and songs with your child’s name, themes, characters, and other creative details.',
    },
  ],

  story: [
    {
      question: 'How do I create a story?',
      answer:
        'Describe your idea, choose characters or themes, and the app will generate a complete story instantly.',
    },
    {
      question: 'Can my child be the hero of the story?',
      answer:
        'Yes. You can include your child’s name and personalize the story so they become the main character.',
    },
    {
      question: 'Can I choose the illustration style?',
      answer:
        'Yes. Stories can include AI-generated illustrations in different artistic styles such as watercolor, cartoon, or fantasy.',
    },
    {
      question: 'Does the story include voice narration?',
      answer:
        'Yes. You can choose from multiple voice-over options or record your own voice for narration.',
    },
  ],
  song: [
    {
      question: 'Can I create songs with lyrics?',
      answer:
        'Yes. The app can generate full songs with lyrics and vocals based on your idea.',
    },
    {
      question: 'Can the song include my child’s name?',
      answer:
        'Yes. You can personalize songs with your child’s name and special themes.',
    },
    {
      question: 'What types of songs can I generate?',
      answer:
        'You can create lullabies, educational songs, or fun adventure songs for kids.',
    },
  ],

  support: [
    {
      question: 'How do I report a technical issue?',
      answer:
        'If you encounter any problems, please use the ‘Contact us’ feature in the app, which will direct you to our support team via email.',
    },
    {
      question: 'Will my stories be saved if I delete my account?',
      answer:
        'Please note that deleting your account will remove all associated data, and stories cannot be recovered afterward.',
    },
    {
      question: 'What should I do if the app is not working properly?',
      answer:
        'If you encounter any issues with the app, please try restarting it or check for updates. If the problem persists, reach out to our technical support team for help.',
    },
    {
      question: 'How can I suggest new features or improvements for FairyTaler?',
      answer:
        'We love hearing from our users! You can send us your suggestions through the ‘Contact us’ option in the app or via our social media channels.',
    },
  ],

  privacy: [
    {
      question: 'How does FairyTaler ensure the safety of my data?',
      answer:
        'FairyTaler takes your privacy seriously. We employ robust security measures to protect your personal information and story content.',
    },
    {
      question: 'What personal data does FairyTaler collect?',
      answer:
        'We collect only the minimal data required to provide the app experience, such as language preferences and optional child profile information.',
    },
    {
      question: 'How does FairyTaler handle data breaches?',
      answer:
        'In the unlikely event of a data breach, we follow strict security protocols and notify affected users if necessary.',
    },
    {
      question: 'How is children’s privacy protected?',
      answer:
        'FairyTaler follows strict privacy practices to ensure children’s data is handled safely and responsibly.',
    },
  ],
};

export default accordionData;